import { createRecipe } from './runtime';

const linkConfig = {"name":"link","defaultVariants":{"mono":false},"variantMap":{"mono":["false","true"]}}

export const link = /* @__PURE__ */ createRecipe(linkConfig)